export const FILE_SIZE_LIMITS = {
  IMAGE: {
    MB: 32,
    BYTES: 32 * 1024 * 1024,
  },
  VIDEO: {
    MB: 100,
    BYTES: 100 * 1024 * 1024,
  },
  DOCUMENT: {
    MB: 10,
    BYTES: 10 * 1024 * 1024,
  },
} as const;

export const ACCEPTED_FILE_TYPES = {
  images: {
    'image/*': [],
    'video/*': [],
  },
  documents: {
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
    'application/vnd.ms-excel': ['.xls'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
    'image/*': [],
  },
} as const;
